import Auth from "../../../libs/API/Auth";
import PaymentsAPI from "../../../libs/API/Payments";
import BrandsAPI from "../../../libs/API/Brands";
import ShoppingCart from "../../../components/shopping-cart/ShoppingCart";
import Alert from "../../../components/Alert";
import AlertConfirm from "../../../components/AlertConfirm";
import ModalRequestRegisterLogin from "../../../components/ModalRequestRegisterLogin";
import { dateToString, stringToDate, gaSendEvent, GTMEvent } from "../../../utils/Utils";

import CampaignPlanningConfirmationBillboardList from "./CampaignPlanningConfirmationBillboardList";
import CampaignPlanningConfirmationPriceDetail from "./CampaignPlanningConfirmationPriceDetail";
import CampaignPlanningConfirmationModalForbidden from "./CampaignPlanningConfirmationModalForbidden";
import CampaignPlanningConfirmationSummary from "./CampaignPlanningConfirmationSummary";
import CampaignPlanningConfirmationModalPayment from "./CampaignPlanningConfirmationModalPayment";
import CampaignPlanningConfirmationModalSendPaymentLink from "./CampaignPlanningConfirmationModalSendPaymentLink";
import CampaignPlanningConfirmationModalSendQuote from "./CampaignPlanningConfirmationModalSendQuote";
import CampaignPlanningConfirmationModalContract from "./CampaignPlanningConfirmationModalContract";
import CampaignPlanningConfirmationAdBuilder from "./CampaignPlanningConfirmationAdBuilder";


class CampaignPlanningConfirmation {
    constructor() {
        this.main = document.getElementById('campaign_planning_confirmation');

        this._list = new CampaignPlanningConfirmationBillboardList();
        this._priceDetailDigital = new CampaignPlanningConfirmationPriceDetail(this.main.querySelector('.stats-digital'));
        this._priceDetailStatic = new CampaignPlanningConfirmationPriceDetail(this.main.querySelector('.stats-static'));
        this._orderSummary = new CampaignPlanningConfirmationSummary();

        this._btnContinue = this.main.querySelector('.btn_continue');
        this._btnContinueSecondary = this.main.querySelector('.btn_continue_secondary');

        this._modalPayment = new CampaignPlanningConfirmationModalPayment();
        this._modalSendPaymentLink = new CampaignPlanningConfirmationModalSendPaymentLink();
        this._modalSendQuote = new CampaignPlanningConfirmationModalSendQuote();
        this._modalContract = new CampaignPlanningConfirmationModalContract();
        this._adBuilderModule = new CampaignPlanningConfirmationAdBuilder();

        this._addMoreLink = this.main.querySelector('.add_more_link');

        this._data = null;
        this._trackingId = null;
        this._customerName = null;
        this._fromDate = null;
        this._toDate = null;
        this._shoppingCartData = null;

        ShoppingCart.initSilent = true;

        Auth.addEventListener('sessionReady', this._onSessionReady.bind(this));
        this._btnContinue.addEventListener('click', this._onClickBtnContinue.bind(this));
        this._btnContinueSecondary.addEventListener('click', this._onClickBtnContinueSecondary.bind(this));
        this._adBuilderModule.addEventListener('adBuilderCreditsChange', (e) => {
            this._orderSummary.loading = true;
            if (e.detail.active) {
                ShoppingCart.setAICredits = e.detail;
            } else {
                ShoppingCart.setAICredits = null;
            }
        });

        window.addEventListener("CREATE_SELF_QUOTES", (e) => {
            this._createShoppingLead(false, true, false);
        });

        window.addEventListener("AD_BUILDER_MODULE_HIDE", (e) => {
            this._adBuilderModule.hide();
        });


        this._modalPayment.addEventListener("CONTACT_SALE_REP", (e) => {
            this._saveCheckoutInfo();
            this._contactSaleRep();
        });

        this._modalPayment.addEventListener("SHOW_CONTRACT_MODAL", (e) => {
            if(e.detail.html){
                this._modalContract.setContract = e.detail.html;
                this._modalContract.show();
            }
        });

        this._modalContract.addEventListener("PAYMENT_FUNNEL", (e) => {
            this._modalPayment.showStatusContent = true;
            this._modalPayment.show();
            this._saveCheckoutInfo();
            this._checkoutFlow();
        });

        this._modalSendPaymentLink.addEventListener("PAYMENT_SEND_LINK_FUNNEL", (e) => {
            this._modalSendPaymentLink.loadingSendLink = true;
            //this._saveCheckoutInfo();
            this._checkoutFlow(true);
        });

        this._modalSendQuote.addEventListener("PAYMENT_SEND_QUOTE_FUNNEL", (e) => {
            this._modalSendQuote.loadingSendQuote = true;
            this._sendQuote();
        });

        window.addEventListener('INTERNAL_TRY_TO_CREATE_SELF_QUOTE', (e) => {
            CampaignPlanningConfirmationModalForbidden.show();
        });

    }

    set loading(value) {
        if (value) {
            this.main.classList.add('skeleton--show');
        } else {
            this.main.classList.remove('skeleton--show');
        }
    }

    _saveCheckoutInfo() {
        let GTMICarttems = [];
        ShoppingCart.data.items.forEach(item => { GTMICarttems.push({ item_id: item.id, item_name: item.name, price: item.price, quantity: '1' }) });
        let objectToSave = { ecommerce: { currency: 'USD', tax: '0', shipping: '0', value: ShoppingCart.getTotalCartNumber, items: GTMICarttems } };
        GTMEvent('begin_checkout', objectToSave);
        localStorage.setItem('last_purchase', JSON.stringify(objectToSave));
    }

    _onSessionReady(isUserLogged) {
        this._customerName = Auth.user.full_name;
        if (ShoppingCart.isReady) {
            this._onShoppingCartReady();
        } else {
            ShoppingCart.addEventListener('cartReady', this._onShoppingCartReady.bind(this));
        }
        if (Auth.isExternalSellerLogged) {
            this._btnContinue.classList.add('button--loading');
            this._btnContinueSecondary.classList.add('button--loading');
            this._btnContinueSecondary.classList.remove('d-none');
        }
    }

    async _onShoppingCartReady(e = null) {
        ShoppingCart.addEventListener('cartChange', this._onShoppingCartChange.bind(this));

        if (Auth.isExternalSellerLogged) {
            const client = await BrandsAPI.getBrandById(ShoppingCart.data.brand.id);

            this._btnContinue.querySelector('.button__text').innerHTML = 'Send payment link';
            this._btnContinue.classList.remove('button--loading');
            this._modalSendPaymentLink.setTotalPrice = ShoppingCart.getTotalCartNumber;
            this._modalSendPaymentLink.setClient = client;

            this._btnContinueSecondary.querySelector('.button__text').innerHTML = 'Send Quote';
            this._btnContinueSecondary.classList.remove('button--loading');
            this._modalSendQuote.setTotalPrice = ShoppingCart.getTotalCartNumber;
            this._modalSendQuote.setClient = client;
        }
        this._update();
    }

    _onShoppingCartChange(e) {
        this._update();
    }

    _checkoutFlow(sendLink = false) {
        this._modalPayment.showStatusContent = true;
        this._modalSendPaymentLink.showStatusContent = true;
        if (Auth.isCustomerLogged || Auth.isExternalSellerLogged) {
            const requestData = {
                brand_id: ShoppingCart.data.brand ? ShoppingCart.data.brand.id : null,
                brand_category_id: ShoppingCart.data.brandCategory ? ShoppingCart.data.brandCategory.id : null,
                list: ShoppingCart.data.items.map((item) => {
                    return {
                        id: item.id,
                        date_range: [dateToString(item.dateRange.from), dateToString(item.dateRange.to)],
                        exclusivity: item.exclusivity,
                        date_filters: {
                            weekdays: item.weekdays,
                        },
                        package: item.package ? { id: item.package.id } : null,
                    }
                }),
                ai_credits: ShoppingCart.data.ai_credits
            }


            Auth.makePrivatePostWithStatus(`${BASE_URL}api/orders`, requestData)
                .then(({ data, status }) => {
                    if (data.data.id) {
                        let payload = {
                            "amount": data.data.price,
                            "payment_method": null,
                        };
                        Auth.makePrivatePostWithStatus(`${BASE_URL}api/customer/orders/${data.data.id}/payments/session`, payload)
                            .then(({ data, status }) => {
                                ShoppingCart.clearWithoutEvents();
                                if (sendLink) {
                                    PaymentsAPI.sendPaymentLink(data.data.id).then((response) => {
                                        this._modalSendPaymentLink.loadingSendLink = false;
                                        this._modalSendPaymentLink.hide();
                                        return AlertConfirm.show({
                                            icon: 'campaign',
                                            title: 'Payment link sent',
                                            description: 'Once the payment is confirmed you can start configuring the campaign.',
                                            acceptBtn: {
                                                text: 'Got it'
                                            }
                                        }).then((confirm) => {
                                            if (confirm) {
                                                AlertConfirm._hide();
                                                window.location.href = `${BASE_URL}bsuite/customer/orders/${data.data.order_id}`;
                                            }
                                        });
                                    })
                                } else {
                                    location.href = data.data.process_url;
                                }
                            }).catch(({ data, status }) => {
                                this._modalPayment.setResponseContent = (status >= 500) ? 'Oops, something went wrong! Try again later.' : data.data.message;
                                this._modalPayment.showResponseContent = true;

                                this._modalSendPaymentLink.setResponseContent = (status >= 500) ? 'Oops, something went wrong! Try again later.' : data.data.message;
                                this._modalSendPaymentLink.showResponseContent = true;
                            });
                    }
                })
                .catch(({ data, status }) => {
                    this._modalPayment.setResponseContent = (status >= 500) ? 'Oops, something went wrong! Try again later.' : data.data.message;
                    this._modalPayment.showResponseContent = true;

                    this._modalSendPaymentLink.setResponseContent = (status >= 500) ? 'Oops, something went wrong! Try again later.' : data.data.message;
                    this._modalSendPaymentLink.showResponseContent = true;
                });
        }

    }

    _sendQuote() {
        const requestData = {
            brand_id: ShoppingCart.data.brand ? ShoppingCart.data.brand.id : null,
            brand_category_id: ShoppingCart.data.brandCategory ? ShoppingCart.data.brandCategory.id : null,
            list: ShoppingCart.data.items.map((item) => {
                return {
                    id: item.id,
                    date_range: [dateToString(item.dateRange.from), dateToString(item.dateRange.to)],
                    exclusivity: item.exclusivity,
                    date_filters: {
                        weekdays: item.weekdays,
                    },
                    package: item.package ? { id: item.package.id } : null,
                }
            }),
            ai_credits: ShoppingCart.data.ai_credits
        };

        Auth.makePrivatePostWithStatus(`${BASE_URL}api/customer/self-quotes`, requestData)
            .then(({ data, status }) => {
                if (data.data.tracking_id) {
                    Auth.makePrivatePostWithStatus(`${BASE_URL}api/customer/self-quotes/${data.data.tracking_id}/send-to-brand-customer`)
                        .then(({ data, status }) => {
                            //ShoppingCart.clearWithoutEvents();
                            this._modalSendQuote.loadingSendQuote = false;
                            this._modalSendQuote.hide();
                            return AlertConfirm.show({
                                icon: 'campaign',
                                title: 'Quote sent',
                                description: 'The quote has been sent to your client.',
                                acceptBtn: {
                                    text: 'Got it'
                                }
                            }).then((confirm) => {
                                if (confirm) {
                                    AlertConfirm._hide();
                                    //window.location.href = `${BASE_URL}billboard-search`;
                                }
                            });
                        }).catch(({ data, status }) => {
                            this._modalSendPaymentLink.setResponseContent = (status >= 500) ? 'Oops, something went wrong! Try again later.' : data.data.message;
                            this._modalSendPaymentLink.showResponseContent = true;
                        });
                }
            })
            .catch(({ data, status }) => {
                this._modalSendQuote.setResponseContent = (status >= 500) ? 'Oops, something went wrong! Try again later.' : data.data.message;
                this._modalSendQuote.showResponseContent = true;
            });
    }

    _checkVerifiedUser(data, callback) {
        if (data) {
            if (data.result) {
                callback();
            }

            if (!data.completed_profile && !data.verified_profile) {
                return AlertConfirm.show({
                    title: `We need to verify your account`,
                    description: 'Before processing your order we have to validate your user account. Please fill your profile page and once we validate your information we will let you know.',
                    cancelBtn: {
                        text: 'Maybe Later'
                    },
                    acceptBtn: {
                        text: 'Complete Profile'
                    },
                }).then(confirm => {
                    if (confirm) {
                        window.location.replace(`${BASE_URL}bsuite/customer/user/profile?redirect=${window.BASE_URL}/campaign-planning-confirmation`);
                    }
                });
            } else if (!data.verified_profile) {
                return AlertConfirm.show({
                    title: `Your account is being verified`,
                    description: 'We are verifying that your profile matches your organization, please wait until we complete the process and you’ll be notified.',
                    acceptBtn: {
                        text: 'Accept'
                    },
                }).then(confirm => {
                    if (confirm) {
                        AlertConfirm._hide();
                    }
                });
            }

        }
    }

    _contactSaleRep() {
        /*let GTMICarttems = [];
        ShoppingCart.data.items.forEach(item => {
            GTMICarttems.push({item_id:item.id, item_name:item.name, price:item.price});
        });
        GTMEvent('save_list',{ecommerce: {currency:'USD', value: ShoppingCart.getTotalCartNumber, items:GTMICarttems}});*/
        this._modalPayment.showStatusContent = true;
        this._createShoppingLead();
    }

    _update() {
        let shoppingCartData = ShoppingCart.data;

        let requestData = {};
        requestData.brand_id = shoppingCartData.cartType == ShoppingCart.TYPE_BRAND ? shoppingCartData.brand.id : null;
        requestData.brand_category_id = shoppingCartData.cartType == ShoppingCart.TYPE_BRAND_CATEGORY ? shoppingCartData.brandCategory.id : null;
        requestData.ai_credits = shoppingCartData.ai_credits;
        requestData.items = [];


        shoppingCartData.items.forEach((item) => {
            if (item.days_available > 0) {

                requestData.items.push({
                    id: item.id,
                    date_range: [dateToString(item.dateRange.from), dateToString(item.dateRange.to)],
                    exclusivity: item.exclusivity,
                    date_filters: {
                        weekdays: item.weekdays
                    },
                    package: item.package ? { id: item.package.id } : null,
                });
            }
        });

        // Envío los ids con sus respectivos dateRange para obtener la data actualizada
        fetch(`${BASE_URL}campaign-planning-confirmation/data`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)

        })
            .then(response => response.json())
            .then((data) => {
                this._modalPayment.setOptions = data;
                this._modalSendPaymentLink.setTotalPrice = ShoppingCart.getTotalCartNumber;
                this._orderSummary.set(data.campaign_summary);
                data.items.forEach((item) => {
                    item.dateRange = { from: stringToDate(item.date_range[0]), to: stringToDate(item.date_range[1]) }
                    delete item.date_range;
                    const requestItem = requestData.items.find((foundItem) => foundItem.id == item.id);
                    item.weekdays = requestItem.date_filters.weekdays ? requestItem.date_filters.weekdays : [];
                })


                this._list.set(data.items, shoppingCartData.brand, shoppingCartData.brandCategory);
                this._priceDetailDigital.set(data.campaign_summary.digital);
                this._priceDetailStatic.set(data.campaign_summary.static);

                if (shoppingCartData.cartType == ShoppingCart.TYPE_BRAND) {
                    this._addMoreLink.href = `${BASE_URL}billboard-search?brand_id=${shoppingCartData.brand.id}`;
                } else if (shoppingCartData.cartType == ShoppingCart.TYPE_BRAND_CATEGORY) {
                    this._addMoreLink.href = `${BASE_URL}billboard-search?brand_category=${shoppingCartData.brandCategory.id}`;
                } else {
                    this._addMoreLink.href = `${BASE_URL}billboard-search`;
                }
                this._btnContinue.classList.remove('button--disabled');
                this.loading = false;
            });
    }

    _onClickBtnContinue(e) {
        e.preventDefault();
        this._canCheckout();
    }

    async _onClickBtnContinueSecondary(e) {
        e.preventDefault();
        this._btnContinueSecondary.classList.add('button--loading');
        let responseToVerify = await Auth.makePrivateGet(`${BASE_URL}api/customer/abilities/can-contact-sales-executive`);
        this._btnContinueSecondary.classList.remove('button--loading');
        const callback = () => this._modalSendQuote.show();
        return await this._checkVerifiedUser(responseToVerify, callback);
    }

    async _canCheckout() {
        if (Auth.isInternalLogged) {
            window.dispatchEvent(new CustomEvent('INTERNAL_TRY_TO_CREATE_SELF_QUOTE'));
            return;
        }

        if (Auth.isCustomerLogged || Auth.isExternalSellerLogged) {
            this._btnContinue.classList.add('button--loading');
            let responseToVerify = await Auth.makePrivateGet(`${BASE_URL}api/customer/abilities/can-contact-sales-executive`);
            this._btnContinue.classList.remove('button--loading');
            let callback = () => this._modalPayment.show();

            if (Auth.isExternalSellerLogged) {
                callback = () => this._modalSendPaymentLink.show();
            }

            return await this._checkVerifiedUser(responseToVerify, callback);
        } else {
            ModalRequestRegisterLogin.show(null, 'The system will remember your Billboards Selection and redirect to this screen.');
        }
    }

    _downloadFile(blob, filename) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    _createShoppingLead(sendEmail = false, contactSales = false, redirectDetail = true) {
        this._shoppingCartData = JSON.parse(JSON.stringify(ShoppingCart.data));
        const user = Auth.user;
        gaSendEvent('Campaign Planning Confirmation', `Click Checkout`, 'Campaign Planning Confirmation Summary');

        if (Auth.isCustomerLogged || Auth.isExternalSellerLogged) {
            const requestData = {
                brand_id: ShoppingCart.data.brand ? ShoppingCart.data.brand.id : null,
                brand_category_id: ShoppingCart.data.brandCategory ? ShoppingCart.data.brandCategory.id : null,
                list: ShoppingCart.data.items.map((item) => {
                    return {
                        id: item.id,
                        date_range: [dateToString(item.dateRange.from), dateToString(item.dateRange.to)],
                        exclusivity: item.exclusivity,
                        date_filters: {
                            weekdays: item.weekdays,
                        },
                        package: item.package ? { id: item.package.id } : null,
                    }
                }),
                ai_credits: ShoppingCart.data.ai_credits
            }

            Auth.makePrivatePost(`${BASE_URL}api/customer/self-quotes`, requestData)
                .then((data) => {
                    this._trackingId = data.tracking_id;
                    ShoppingCart.clearWithoutEvents();
                    Auth.makePrivatePost(`${BASE_URL}bsuite/customer/self-quotes/${this._trackingId}/require-sales-executive-async`)
                        .then(() => {
                            this._modalPayment.hide();
                            GTMEvent('finish_checkout', { trackingId: this._trackingId });
                            Alert.show('campaigns', 'Awesome! We have send your request to one of our Sales Rep.', 'We will contact you ASAP.', 'Got it').then((confirm) => {
                                if (confirm) {
                                    location.href = data.url;
                                }
                            })
                        })
                        .catch((a) => {
                            this._modalPayment.hide();
                            Alert.show('warning', 'Something went wrong, please try again later.', null, 'Ok');
                        })
                })
                .catch(() => {
                    this._modalPayment.hide();
                    Alert.show('warning', 'Something went wrong, please try again later.', null, 'Ok');
                });
        }
    }

}

export default CampaignPlanningConfirmation;